<template>
  <div class="containerBox">
    <div
      src="@/assets/image/xplan/analysisText.png"
      class="title wow animate__animated durationTime animate__fadeInUp"
      alt=""
    >
      专业顾问为您测算
    </div>
    <div
      src="@/assets/image/xplan/analysisText.png"
      class="subTitle wow animate__animated durationTime animate__fadeInUp"
      alt=""
    >
      留下您的联系方式，我们会有专业顾问为您答疑解惑
    </div>
    <div class="content">
      <el-form class="feedForm" ref="form" :model="form" label-width="0px">
        <el-form-item label="" prop="name">
          <el-input v-model="form.name" placeholder="请输入您的姓名"></el-input>
        </el-form-item>
        <el-form-item label="" prop="region">
          <my-address @childEvent="handRegionData"></my-address>
<!--          <el-select v-model="form.region" placeholder="地区" clearable>-->
<!--            <el-option label="地区一" value="shanghai"></el-option>-->
<!--            <el-option label="地区二" value="beijing"></el-option>-->
<!--          </el-select>-->
        </el-form-item>

        <el-form-item label="" prop="type">
          <el-select
            v-model="form.type"
            placeholder="规模（人数，按梯度选择）"
            clearable
          >
            <el-option
              v-for="item in populationSize"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" prop="mobile">
          <el-input
            v-model="form.mobile"
            placeholder="请输入您的联系方式"
          ></el-input>
        </el-form-item>
<!--        <div class="checkBoxCon">-->
<!--          <el-checkbox v-model="form.isRead"-->
<!--            >我仔细阅读并接受所附的<span class="spanLight"-->
<!--              >隐私条款</span-->
<!--            ></el-checkbox-->
<!--          >-->
<!--        </div>-->
        <el-button type="default" class="subBtn" @click="onSubmit"
          >提交测算<img src="@/assets/image/xplan/feedbackIcon1.png" alt=""
        /></el-button>
        <div class="tip">*稍后有项目顾问18665393445致电为您详细解读报价</div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";
import {Message} from 'element-ui'

export default {
  data() {
    return {
      form: {
        name:'',
        region:'',
        mobile:'',
        type:'',
        isRead:false
      },
      qrCode:'',
      populationSize:[{"label":"1000以内","value":"1000以内"},{"label":"1000-2000","value":"1000-2000"},{"label":"2000-3000","value":"2000-3000"},{"label":"3000以上","value":"3000以上"}]
    };
  },
  computed: {},
  mounted() {
    // init wow
    const wow = new WOW({
      boxClass: "wow", //需要执行动画元素的Class
      animateClass: "animated_lightSpeedIn", //animation.css动画的Class
      offset: 0, //距离可视区域多少开始执行动画
      mobile: true, //是否在移动设备执行动画
      live: true //异步加载的内容是否有效
    });
    wow.init();
    let wl = document.createElement("script");
    wl.type = "text/javascript";
    wl.src = "https://material.weiling.cn/h5/willing-third-party-js/v1/form-custom-comp-v1.js";
    wl.id = "wlCUSFORM";
    wl.onload = function() {
      wlCustomFormComp.init({
        wl_id: "wpW2WmDAAAsuSkpyHYrwjV4tnMu-Zjag", // 企业的唯一id,在代码文档.txt中获得
      });
    };
    if (!document.getElementById("wlCUSFORM")) {
      let s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(wl, s);
    }
  },
  methods: {
    //从子组件得到地区的值
    handRegionData(data){
      this.form.region=data
    },
    onSubmit() {
      let that=this;
      if(this.$refs.form){
        wlCustomFormComp.linkToWL(
          {
            wl_form_id: "1801155502135181312", // 需要使用的卫瓴移动表单ID，从代码文档.txt中获得
            formData: {
              user_name: this.form.name, // KEY的值详见下方表单参数
              mobile: this.form.mobile,
              // population_size:this.form.type,
              region:this.form.region,
              select_01:this.form.type
            },  // 用户的其他信息
          },
          that.callback
        );


        this.form.isRead=false
        this.$refs.form.resetFields()
      }
    },
    open() {
      this.$alert('<img src="'+this.qrCode+'"/>', '扫码', {
        dangerouslyUseHTMLString: true
      });
    },
    callback(data){
      console.log(data); // data中包含二维码图片地址
      if(data.code===200){
        Message.success("提交成功！")
        console.log(data.qr_code);
        this.qrCode=data.data.qr_code;
        // this.open();
      }else {
        Message.error("提交失败,可直接打电话和我们联系!")
      }
    }
  }
};
</script>

<style scoped lang="scss">
.containerBox {
  width: 100%;
  padding: 1rem 0 1.16rem;
  background: url(../../../assets/image/xplan/feedbackBg.png) center no-repeat;
  background-size: cover;
  .title {
    font-weight: 500;
    font-size: 0.53rem;
    margin-bottom: 0.2rem;
    text-align: center;
    color: #fff;
  }
  .subTitle {
    font-weight: 400;
    font-size: 0.24rem;
    margin-bottom: 0.4rem;
    text-align: center;
    color: #fff;
  }
  .content {
    width: 8.9rem;
    padding: 0.5rem 1.53rem 1.05rem;
    border-radius: 0.2rem;
    margin: 0 auto;
    background: linear-gradient(
      90deg,
      rgba(#ffffff, 0.7) 0%,
      rgba(#9b9c9f, 0.9) 100%
    );
  }
}
</style>

<style scoped>
.feedForm {
  .el-form-item {
    margin-bottom: 0.3rem;
  }
  .el-form-item__content {
    line-height: 0.52rem;
    font-size: 0.18rem;
  }
  .el-input {
    font-size: 0.18rem;
  }
  .el-input__inner {
    background-color: transparent;
    border-radius: 0;
    border: 0;
    color: #000;
    height: 0.52rem;
    line-height: 0.52rem;
    width: 100%;
    padding: 0;
    border-bottom: 1px solid #fef100 !important;
  }
  .el-select {
    width: 100%;
  }
  .el-select .el-input .el-select__caret {
    color: #fef100;
    font-size: 0.2rem;
  }
  .checkBoxCon {
    display: flex;
    justify-content: center;
    padding: 0.3rem 0 0.4rem;
    .el-checkbox {
      color: #333 !important;
      font-weight: 400;
      font-size: 0.18rem;
    }
    .el-checkbox__inner {
      border: 1px solid #333 !important;
      background-color: transparent !important;
    }
    .spanLight {
      color: #fef100;
      margin-left: 0.04rem;
      text-decoration: underline;
    }
  }
  .el-checkbox__label {
    display: inline-block;
    padding-left: 0.12rem;
    font-size: 0.18rem;
    color: #333 !important;
  }
  .subBtn {
    width: 100%;
    height: 0.48rem;
    line-height: 0.48rem;
    border: 1px solid #fef100;
    background: transparent !important;
    padding: 0;
    font-size: 0.18rem;
    border-radius: 0.3rem;
    color: #333333 !important;
    transition: all 0.3 ease-in-out;
    margin-bottom: 0.2rem;
    img {
      width: 0.15rem;
      height: 0.15rem;
      margin-left: 0.11rem;
    }
    &:hover {
      background: rgba(255, 255, 255, 0.2) !important;
    }
  }
  .tip {
    font-size: 0.12rem;
    text-align: center;
    color: rgba(#333333, 0.6);
  }
}
</style>
<style>
.feedForm .el-input__inner::-webkit-input-placeholder {
  color: #333;
}
.feedForm .el-input__inner::-ms-input-placeholder {
  color: #333;
}
.feedForm .el-input__inner::-moz-input-placeholder {
  color: #333;
}
.feedForm .checkBoxCon .el-checkbox__inner::after {
  border: 1px solid #333 !important;
  border-left: 0 !important;
  border-top: 0 !important;
}
.el-select-dropdown__item{
  font-size: 0.18rem;
}
.el-select-dropdown__item.selected{
  color: #333 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/xplan/components/feedback.vue